import { get, find, values, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getReservationToday = get('reservation.today');

export const getAll = createSelector(getReservationToday, get('all'));

export const getAllValues = createSelector(getAll, values);

export const getItemForBarcode = createSelector(
  (_, code) => ({ code }),
  getAllValues,
  find
);

export const getOrderedToday = createSelector(
  getAllValues,
  orderBy('id', 'desc')
);

export const getOrder = createSelector(getReservationToday, get('order'));

export const getIsFetching = createSelector(
  getReservationToday,
  get('fetching')
);
export const getIsFetched = createSelector(getReservationToday, get('fetched'));

export const getFetchingError = createSelector(
  getReservationToday,
  get('fetchingError')
);

export const getIsSaving = createSelector(getReservationToday, get('saving'));

export const getIsSaved = createSelector(getReservationToday, get('saved'));
